<script lang="ts">
  import CategoryList from "./Components/CategoryList.svelte";
  import {
    buildCategoryTree,
    buildCategoryTree2,
    flattenSelected,
    selectChildren,
  } from "./lib/Category";
  import PubSub from "pubsub-js";
  import TagList from "./Components/TagList.svelte";
  import PriceSlider from "./Components/PriceSlider.svelte";
  import { init, _ } from "svelte-i18n";
  import axios from "axios";
  import config from "./config";

  export let lang;

  let categories = [];
  let tags = [];
  let min_price = 0;
  let max_price = 1000;
  let currency = "kn";

  let show_more_tags =
    typeof a3_show_more_tags !== "undefined" ? a3_show_more_tags : true;

  (async () => {
    const response = await axios.post(
      `${config.api_url[a3_env]}/api-elastic/${a3_elastic_index}/get_categories/${a3_env}-taxonomy-product_*/_search?size=1000`
    );

    const terms = response?.data?.hits?.hits?.map((term) => term._source) ?? [];

    const current_term_id =
      typeof a3_current_term_id !== "undefined" ? a3_current_term_id : 0;
    const selectedCategories =
      typeof a3_filter_ctgs !== "undefined"
        ? a3_filter_ctgs
        : [current_term_id];

    categories = buildCategoryTree2(
      terms?.filter((term) => term.taxonomy === "product_cat"),
      selectedCategories
    );
    tags = buildCategoryTree(
      terms?.filter((term) => term.taxonomy === "product_tag"),
      current_term_id ?? 0
    );
  })().catch((exc) => {
    // Deal with the fact the chain failed
    console.log(exc);
  });

  const onSelectCategory = (ev) => {
    console.log("onSelectCategory");
    selectCategory(ev.detail.category);
  };

  const selectCategory = (category) => {
    selectChildren(category);
    categories = categories; // reload category array, refreshes category view

    const selectedCategories = flattenSelected(categories);

    console.log({ selectedCategories });

    PubSub.publish("CATEGORY_FILTER_CHANGED", {
      selectedCategories,
      selectedTopCategories: categories
        .filter((tlc) => tlc.selected)
        .map((tlc) => tlc.term_id),
    });
  };

  const onSelectRange = (ev) => {
    console.log(ev.detail.values);

    PubSub.publish("PRICE_FILTER_CHANGED", { priceRange: ev.detail.values });
  };

  const productsFiltered = (msg, data) => {
    console.log(msg, data);
    const aggs = data?.result?.aggs;

    min_price = aggs.min_price.value / 100;
    max_price = aggs.max_price.value / 100;
  };

  const initLang = (lang) => {
    if (!lang) {
      const htmlTag = document.getElementsByTagName("html")[0];
      lang = htmlTag?.getAttribute("lang") ?? "en-US";
    }

    init({
      fallbackLocale: "en-US",
      initialLocale: lang,
    });
  };

  initLang(lang);

  console.log(categories);

  PubSub.subscribe("PRODUCTS_FILTERED", productsFiltered);
</script>

<div
  id="woocommerce_product_categories-1"
  class="widget woocommerce widget_product_categories"
>
  <span class="gamma widget-title">{$_("sidebar.Explore")}</span>

  <CategoryList bind:categories on:categorySelected={onSelectCategory} />
</div>

<!-- <div id="woocommerce_price_filter-1" class="widget woocommerce widget_price_filter">
	<span class="gamma widget-title">{$_('sidebar.Price')}</span>

	<PriceSlider {min_price} {max_price} {currency} on:rangeSelected={onSelectRange}></PriceSlider>
</div> -->

{#if tags.length > 0}
  <TagList bind:tags showMore={show_more_tags} />
{/if}

<style>
</style>
